function openCollectionSlider(evt, collection, cls, index) { 
console.log('.slick-' + '#' + collection + ' #Slider-' + cls)
  console.log(".col" + index + "-fc-slider-comp-" + cls)
  var content = $('.slick-' + collection).html();


   $(".col" + index + "-fc-slider-comp-" + cls).slick('unslick');
			
  $('#' + collection + ' #Slider-' + cls).empty();
  
  $('#' + collection + ' #Slider-' + cls).html(content);

  
  // Remove style using jQuery
  $('#' + collection).removeAttr('style');
  
  // Resize the slick slider using jQuery
   $(".col" + index + "-fc-slider-comp-" + cls).slick({
      arrow: true,
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 2,  
      responsive: [
        {
          breakpoint: 768,
          settings: {
            autoplaySpeed:4000,
            lazyLoad:"progressive",
            speed:600,
            arrows:false,
            loop: false,
            infinite: false,
            swipe: true,  
            prevArrow: '<div class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></div>',
            nextArrow: '<div class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
            dots:true,  			    
            cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
	});
  
  // Hide all tab content elements with the class "col-tabcontent-" + cls
  $(".col-tabcontent-" + cls).hide();
  
  // Remove "active" class from all tab links with the class "col-tablinks-" + cls
  $(".col-tablinks-" + cls).removeClass("active");
  
  // Show the selected collection by ID
  $('#' + collection).show();
  
  // Add "active" class to the clicked tab link
  $(evt.currentTarget).addClass("active");
}
